import { render, staticRenderFns } from "./ScheduledMassMessageStatView.vue?vue&type=template&id=7353cca2&scoped=true&"
import script from "./ScheduledMassMessageStatView.vue?vue&type=script&lang=ts&"
export * from "./ScheduledMassMessageStatView.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduledMassMessageStatView.vue?vue&type=style&index=0&id=7353cca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353cca2",
  null
  
)

export default component.exports